export const CommunicationsModalTabIds = {
  EMAIL: "email",
  WHATSAPP: "whatsapp",
} as const;

export type CommunicationsModalTabIds =
  (typeof CommunicationsModalTabIds)[keyof typeof CommunicationsModalTabIds];
